var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg360Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1273.25 437.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3abca5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m304.47,194.01v-60.89H0V41.78h319.69c50.74,0,76.11,25.38,76.11,76.12v243.57c0,50.75-25.38,76.11-76.11,76.11H0v-91.34h304.47v-60.89H0v-91.34h304.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m514.84,41.78h319.69v91.34h-304.46v60.89h228.35c50.74,0,76.11,25.38,76.11,76.12v91.34c0,50.75-25.38,76.11-76.11,76.11h-243.58c-50.75,0-76.11-25.36-76.11-76.11V117.9c0-50.74,25.36-76.12,76.11-76.12Zm15.23,243.57v60.89h213.13v-60.89h-213.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1197.13,41.79h-74.81l46.22,46.22-45.12,45.12h58.5v213.12h-213.12v-213.12h77.16v42.89l88.01-88.01-46.22-46.22h0L1045.95,0v41.79h-92.38c-50.77,0-76.12,25.35-76.12,76.12v243.55c0,50.77,25.35,76.12,76.12,76.12h243.55c50.77,0,76.12-25.35,76.12-76.12V117.91c0-50.77-25.35-76.12-76.12-76.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360Svg);
export default __webpack_public_path__ + "static/media/360_SVG.43b4c4c4d8c875ed4511238d4ec12f38.svg";
export { ForwardRef as ReactComponent };